import { COUNTRIES_BY_CODE } from './constants';

export const getPlatformMetricExpectedValue = (platformMetric, metricType) => {
  const metricSuffix = `${metricType.charAt(0).toUpperCase()}${metricType.slice(
    1,
  )}`;
  return (
    platformMetric[`ai${metricSuffix}`]?.value ||
    platformMetric[`expected${metricSuffix}`]?.value ||
    0
  );
};

export const getCountryName = (code) =>
  COUNTRIES_BY_CODE[code.toLowerCase()] || code;
